import React, { ReactElement } from 'react';
import styled from 'styled-components';
import ReactIcon from '@mdi/react';
import { mdiArrowRight } from '@mdi/js';

// import { Typography } from 'components';
// import { Flex, ButtonIcon } from 'components';
import { Link } from 'react-router-dom';
import { useSchool } from 'features/school';

interface SidebarButtonProps {
  label: string;
  help?: string;
  to: string;
}

// const ButtonWrapper = styled(Link)`
//   display: flex;
//   flex-grow: 1;
//   justify-content: space-between;
//   align-items: center;
//   background: transparent;
//   padding: 0;
//   border: 0;
//   outline: none;
//   cursor: pointer;

//   padding: 20px;
//   background: ${({ theme }) => theme.colors.gray_100};
//   border-bottom-left-radius: 4px;
//   border-bottom-right-radius: 4px;

//   &:hover {
//   }
// `;

const BadgeButton = styled('button')`
  position: relative;
  flex-grow: 1;
  padding: 0;
  border: 0;
  text-align: left;
  margin: 0;
  padding: 15px 20px 10px 20px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  text-transform: uppercase;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  cursor: pointer;
`;

const BadgeButtonIcon = styled(ReactIcon)`
  width: 24px;
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
`;

const BadgeLink = styled(Link)<{ schoolalias: string }>`
  display: flex;
  flex-grow: 1;

  ${BadgeButton} {
    background: ${({ theme, schoolalias }) => (schoolalias === 'b3' ? theme.colors.primary_400 : theme.colors.gray_100)};
    color: ${({ theme, schoolalias }) => (schoolalias === 'b3' ? theme.colors.dark_350 : theme.colors.primary_400)};
  }

  ${BadgeButtonIcon} {
    color: ${({ theme, schoolalias }) => (schoolalias === 'b3' ? theme.colors.dark_350 : theme.colors.primary_400)};
  }

  &:hover {
    ${BadgeButton} {
      background: ${({ theme, schoolalias }) => (schoolalias === 'b3' ? theme.colors.primary_200 : theme.colors.primary_400)};
      color: ${({ theme, schoolalias }) => (schoolalias === 'b3' ? theme.colors.dark_350 : theme.colors.white)};
    }

    ${BadgeButtonIcon} {
      color: ${({ theme, schoolalias }) => (schoolalias === 'b3' ? theme.colors.dark_350 : theme.colors.white)};
    }
  }
`;

const SidebarButton = ({ label, help, to }: SidebarButtonProps): ReactElement => {
  const { schoolAlias } = useSchool();

  return (
    <>
      {/* <ButtonWrapper to={to}>
      <Flex flexGrow={0} alignItems="center">
        <Typography type="type3" fontWeight="bold"></Typography>
      </Flex>

      <Flex flexGrow={0} alignItems="center">
        {Boolean(help) && (
          <Typography type="type2" color="gray_500" mr={{ d: 3 }}>
            {help}
          </Typography>
        )}
        <ButtonIcon icon="arrowRight" iconWidth={25} bg="transparent" color="primary_400" />
      </Flex>
    </ButtonWrapper> */}

      <BadgeLink to={to} schoolalias={schoolAlias}>
        <BadgeButton>
          {label}
          <BadgeButtonIcon path={mdiArrowRight} />
        </BadgeButton>
      </BadgeLink>
    </>
  );
};

export default SidebarButton;
